import { render, staticRenderFns } from "./orderKPI.vue?vue&type=template&id=2d0e159b&scoped=true"
import script from "./orderKPI.vue?vue&type=script&lang=js"
export * from "./orderKPI.vue?vue&type=script&lang=js"
import style0 from "./orderKPI.vue?vue&type=style&index=0&id=2d0e159b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e159b",
  null
  
)

export default component.exports